export default () => import(/* webpackChunkName: 'coffee/wechat-community/guide-welfare' */ './GuideWelfare');